module.exports = __webpack_public_path__ + "static/media/vocare.080ca357.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/vocare.png
// module id = 229
// module chunks = 0